import React from "react";

function InputDesign() {
  return (
    <div className="flex gap-4 items-start">
      <div className="w-[390px]">
        <div className="flex gap-5 py-2.5 pr-10 pl-2.5 bg-white">
          <img
            src="https://api.builder.io/api/v1/image/assets/TEMP/b0c76b7ef010c346877e6f81aa9f09f092add8eb?placeholderIfAbsent=true"
            className="object-contain shrink-0 aspect-square w-[60px]"
            alt="Service icon"
          />
          <div className="flex flex-col my-auto">
            <div className="text-xl font-semibold leading-tight text-zinc-800">
              Full wash in\out
            </div>
            <div className="self-start text-sm leading-loose text-gray-500">
              services{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InputDesign;
